// Phase 18 Plan 06 — POLISH-11 $fontScale persistent atom.
//
// Mirrors the $themeKey / $locale / $motionPref pattern (persistent enum atom
// with a strict decode guard). Toggled from Settings → Accessibility → Text
// size segmented pill (FontScaleToggle.tsx). RootApp subscribes and mirrors
// the value onto documentElement.dataset.fontScale so CSS can key off
// [data-font-scale="1.15"] / [data-font-scale="1.30"] to rescale every
// --font-size-* token via calc(N × var(--font-scale)).

import { persistentAtom } from '@nanostores/persistent'

export type FontScale = '1.0' | '1.15' | '1.30'

export const FONT_SCALES: ReadonlyArray<FontScale> = ['1.0', '1.15', '1.30']
export const DEFAULT_FONT_SCALE: FontScale = '1.0'

export function isFontScale(v: unknown): v is FontScale {
  return v === '1.0' || v === '1.15' || v === '1.30'
}

export const $fontScale = persistentAtom<FontScale>(
  'runegambit.fontScale',
  DEFAULT_FONT_SCALE,
  {
    encode: (v) => v,
    decode: (s) => (isFontScale(s) ? s : DEFAULT_FONT_SCALE),
  },
)
